import type { Content, ContentHref } from '@generalTypes/apiTypes';
import { createTypedSelector } from '@newStore/genericHelpers';
import { selectKrcReferenceFrameContent } from '@newStore/referenceFrames/referenceFramesSelectors';
import { selectReferenceFrameGoalSetsPositionMap } from '@newStore/validation/validationRules/krcGoalSetItemOrderValidation';

export const selectGoalSets = createTypedSelector(
  [
    (state) => selectKrcReferenceFrameContent(state),
    (state) => selectReferenceFrameGoalSetsPositionMap(state),
  ],
  (content, positionMap): Content[] => {
    const goalSets = Object.keys(content)
      .filter((key) => content[key as ContentHref].type === 'KRC_GOAL_SET')
      .map((key) => content[key as ContentHref]);

    if (!positionMap.size) {
      return goalSets;
    }

    return goalSets.sort((a, b) => {
      const posA = positionMap.get(a.$$meta.permalink) ?? Number.MAX_SAFE_INTEGER;
      const posB = positionMap.get(b.$$meta.permalink) ?? Number.MAX_SAFE_INTEGER;
      return posA - posB;
    });
  },
);
